import React from 'react';

import { TerminationPreviewModalProps } from './TerminationPreviewModal.interfaces';
import { useStyles } from './TerminationPreviewModal.styles';
import { useTerminationPreviewModal } from './useTerminationPreviewModal';
import { TerminationPreviewDocument } from 'app/components/TerminationPreviewDocument';
import { CompactModal } from 'app/components/CompactModal';
import { CloseIconButton } from 'app/components/CloseIconButton';

export default function TerminationPreviewModal({
  onClose,
}: TerminationPreviewModalProps) {
  const classes = useStyles();

  const { documentRef, scaleWrapperRef, scale } = useTerminationPreviewModal();

  return (
    <CompactModal
      className={classes.sidebarPreviewModal}
      onClose={onClose}
      withoutHeaderCloseButton
    >
      <div ref={scaleWrapperRef} className={classes.scaleWrapper}>
        <div
          ref={documentRef}
          className={classes.document}
          style={{ transform: `translate(-50%, -50%) scale(${scale})` }}
        >
          <div
            className={classes.closeBtn}
            style={{ transform: `scale(${1 / scale})` }}
          >
            <CloseIconButton
              onClick={onClose}
              className={classes.headerCloseButton}
            />
          </div>
          <TerminationPreviewDocument />
        </div>
      </div>
    </CompactModal>
  );
}
